module.exports = __webpack_public_path__ + "assets/1792649897182/img/coupon-bg.b6120a31.png";